import React from 'react';
import PropTypes from 'prop-types';
import './menu-headerbar.scss';

export const MenuHeaderbar = ({ 
  text,
  aria,
...props
}) => {
  return (
    <div className={`menu-headerbar-component`}>
      <div
        className={`menu-headerbar`}
        aria-label={aria ? aria : `${text} Header`}
        data-testid='menu-headerbar'
      >
        <span>{text}</span>
      </div>
    </div>
  );
};

MenuHeaderbar.propTypes = {
  text: PropTypes.string,
  aria: PropTypes.string,
};
